import { SFPillStepper } from "@sf-core";
import { Logger } from "@base-provider";

const PillStepper = () => {
  const steps = [
    {
      label: "Entry",
      content: "Entry content",
    },
    {
      label: "Intermediate",
      content: "Intermediate content",
      onClick: () => {
        Logger.of("App.mock.pillStepper.step.onClick").info(
          "Intermediate Clicked"
        );
        return true;
      },
    },
    {
      label: "Advanced (disabled)",
      content: "Advanced content",
      disabled: true,
    },
    {
      label: "Mastery",
      content: "Mastery content",
    },
  ];
  return <SFPillStepper steps={steps} />;
};

export default PillStepper;
